"use client";
import { useCurrency } from "@/app/providers/currencyContext";
import React from "react";
import { useTranslations } from "next-intl";

export const SingleProductImageFocusedPrice = ({
  product,
  isGiftCardProduct,
}: any) => {
  const { format } = useCurrency();
  const t = useTranslations("SingleProductImageFocusedPrice");

  const formatPrice = (price: number) => {
    return format(price);
  };

  if (!product.available) {
    return (
      <div className="flex items-center">
        <p
          className={["line-through font-normal text-base leading-6"].join(" ")}
        >
          {formatPrice(product.price)}
        </p>
        <span
          className={["ml-2 truncate font-normal text-base leading-6"].join(
            " "
          )}
        >
          {t("unavailable")}
        </span>
      </div>
    );
  }

  return (
    <p className="font-normal text-base leading-6">
      {!isGiftCardProduct ? formatPrice(product.price) : t("customValue")}
    </p>
  );
};
